import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';

import { cn } from '@/lib/utils';

type ProgressProps = React.ComponentProps<typeof ProgressPrimitive.Root> & {
  variant?: 'default' | 'success' | 'destructive';
};

function Progress({
  className,
  variant = 'default',
  value,
  ...props
}: ProgressProps) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        'relative h-2 w-full overflow-hidden rounded-full bg-hatch',
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          variant === 'default' &&
            'h-full w-full flex-1 rounded-full bg-primary transition-all duration-500 ease-[var(--ease-standard)]',
          variant === 'success' &&
            'h-full w-full flex-1 rounded-full bg-success transition-all duration-500',
          variant === 'destructive' &&
            'h-full w-full flex-1 rounded-full bg-destructive transition-all duration-500',
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
